export const MIN_PASSWORD_LENGTH = 6;
export const GOOD_PASSWORD_LENGTH = 10;

export const NUMBERS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
export const SPECIAL_CHARS = ['!', '&', '?', '*', '#', '-', '_', ')', '('];
